import { api, apiClient, config, debug, form, formHelpers, Formsy, i18n, inject, mui, observable, observer, pr, React, RouteComponentProps, theme, ui } from "aaa";
import { action, computed, toJS } from "mobx";
import * as _ from "lodash";

// as used by the users screens
export const AMOUNT_RANGE_STEP = 1000;

// as configurable on the cms interest-rates screen
export const CONFIG_AMOUNT_MIN = AMOUNT_RANGE_STEP;
export const CONFIG_AMOUNT_MAX = 1000000;
export const CONFIG_DURATION_MIN = 1;
export const CONFIG_DURATION_MAX = 35;

export function interestSetsMatch(lhs: Partial<api.IInterestSet>, rhs: Partial<api.IInterestSet>, compareDate = true): boolean {
    if (compareDate && lhs.validFrom !== rhs.validFrom) {
        debug.log("### date mismatch");
        return false;
    }

    const interestMatch = _.isEqual(toJS(lhs.interestInPercent), toJS(rhs.interestInPercent))
        && _.isEqual(toJS(lhs.interestEffectiveInPercent), toJS(rhs.interestEffectiveInPercent))
        && _.isEqual(toJS(lhs.minAmount), toJS(rhs.minAmount))
        && _.isEqual(toJS(lhs.maxAmount), toJS(rhs.maxAmount))
        && _.isEqual(toJS(lhs.minDuration), toJS(rhs.minDuration))
        && _.isEqual(toJS(lhs.maxDuration), toJS(rhs.maxDuration));

    debug.log("### interestInPercent", toJS(lhs.interestInPercent), toJS(rhs.interestInPercent));
    debug.log("### interestEffectiveInPercent", toJS(lhs.interestEffectiveInPercent), toJS(rhs.interestEffectiveInPercent));
    debug.log("### minAmount", toJS(lhs.minAmount), toJS(rhs.minAmount));
    debug.log("### maxAmount", toJS(lhs.maxAmount), toJS(rhs.maxAmount));
    debug.log("### minDuration", toJS(lhs.minDuration), toJS(rhs.minDuration));
    debug.log("### maxDuration", toJS(lhs.maxDuration), toJS(rhs.maxDuration));

    if (!interestMatch) {
        return false;
    }

    const repExMatch = _.isEqual(toJS(lhs.repExes), toJS(rhs.repExes));
    debug.log("### repex match", lhs.repExes, rhs.repExes);
    return repExMatch;
}

export class InterestRates {
    @observable
    isLoadingInterestRates = false;

    @observable
    interestRates: api.IInterestSet | undefined;

    @observable
    interestRatesUpcoming: api.IInterestSet | undefined;

    @computed
    get durationArray() {
        if (!this.interestRates) {
            return [];
        }

        // e.g. [1, 2] -> one year or two years
        return _.range(this.interestRates.minDuration, this.interestRates.maxDuration + 1);
    }

    @computed
    get durationArrayUpcoming() {
        if (!this.interestRatesUpcoming) {
            return [];
        }
        return _.range(this.interestRatesUpcoming.minDuration, this.interestRatesUpcoming.maxDuration + 1);
    }

    @action load = async () => {

        try {
            debug.log("### Base url", config.API_BASE_URL);

            this.isLoadingInterestRates = true;
            this.interestRates = await apiClient.requestType(api.getInterestRates());
            this.interestRatesUpcoming = await apiClient.requestType(api.getInterestRatesUpcoming(), true);

            // const repExRequest = api.getRepExText();
            // const repEx = await apiClient.requestType(repExRequest, true);
            // this.representativeExampleText = repEx.repExText;
            this.isLoadingInterestRates = false;
        } catch (error) {
            this.isLoadingInterestRates = false;
            debug.log("### Error getting interest rates", error);
            throw error;
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/models/InterestRates.ts